import React from 'react'

class HomeComponent extends React.Component {
    render() {
        return <div className="homeDiv">
                <div className="homePics">
                    <img src={require("./item.jpg")}/>
                    <img src={require("./item1.jpg")}/>
                    <img src={require("./item4.jpg")}/>
                </div>
                <div className="homeDsc">
                    <h2>Granwood veikla:</h2>
                    <div className="columns">
                            <span>Granuliatoriai</span>
                            <span>Džiovyklos pjuvenoms</span>
                                             
                            <span>Presai</span>
                            <span>Fasavimo įranga</span>
                        

                    </div>



                </div>
                <div className="items">
                    <div>
                        <h3>Granuliatoriai</h3>
                        <p>Granulių gamybos linijos, granuliatoriai, našumas: 80-2000 kg/h (priklausomai nuo žaliavos)</p>
                
                    </div>
                    <div>
                        <h3>Presai</h3>
                        <p>Briketų gamybos presai: hidrauliniai briketų presai ir mechaniniai apvaliu briketų presai</p>
                    </div>
                    <div>
                        <h3>Džiovyklos pjuvenoms</h3>
                        <p>Našumas 500-2000 kg/val (priklausomai nuo žaliavos)</p>
                
                    </div>
                    <div>
                        <h3>Fasavimo įranga</h3>
                        <p>Automatinė, pusiau automatinė, rankinė.</p>
                    </div>
                    
                </div>
            </div>
}
}

export default HomeComponent